import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import '../css/InstantScreens/Instant.css';
import preview_image from '../assets/clients-preview.png';
import Spinner from 'react-bootstrap/Spinner'

import { StringUtils } from '../utils';
import { Routes as routes, History as history } from '../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, ToastActions } from '../actions';
import { SwitchAccount, TitleBar, NavBar, PracticeCodeInfo, PracticeStaff, PracticeAdmins, Header, Input, PhoneInput, Line, PracticeLocationClients } from  '../components'

class ClientsScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      email: '',
      location_id: '',
      location_clients: {},
      invite_email: '',
      invite_phone_number: '',
      invite_client_method: 'email',
      invite_location_id: '',
      create_client_loading: false,
      invite_client_loading: false,
    }
  }

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('clients');
    this.fetchClientsForLocations(this.props.practice.locations);
    this.props.practiceActions.getSelectedPractice();
  }

  renderContentContainers = () => {
    let practice        = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    let display_clients = practice && practice.subscription && (practice.subscription.subscription_type === 'CORE' || practice.subscription.subscription_type === 'ENTERPRISE');

    if (display_clients) {
      return <div className="flex-container screen-main-content" style={{ }}>
        <div className='flex-container-column' style={{ width: 300, height: 500, marginTop: 25, marginRight: 25 }}>
          { this.renderAddClientForm()    }
        </div>
        <div className='flex-container-column' style={{ width: 500, height: 500, marginTop: 25, marginRight: 25 }}>
          <PracticeCodeInfo practice={practice} clients_screen={true} />
          { this.renderClientLocations() }
        </div>
        <div className='flex-container-column' style={{ width: 300, height: 300, marginTop: 25 }}>
          { this.renderInviteClientForm() }
        </div>
      </div>
    } else {
      return <div className="flex-container screen-main-content" style={{  }}>
        <div className='flex-container-column' style={{ marginTop: 25 }}>
          { this.renderInstantClientsPreview() }
        </div>
      </div>
    }

  }

  renderInstantClientsPreview = () => {
    return <div className='standard-container' style={{ width: 700, maxWidth: 700, minWidth: 700, flex: 1 }}>
      <div className='flex-container-column' style={{ padding: 15, alignItems: 'center' }}>
        <span style={{ fontWeight: 'bold', fontSize: 14, letterSpacing: 0.4, marginTop: 2, color: '#575757' }}>Available only to Professional and Enterprise plans</span>
        <div style={{ height: 2, backgroundColor: '#1dc2ff', width: 540, borderRadius: 10, marginTop: 5, marginBottom: 3 }}></div>
        <span style={{ fontSize: 13, letterSpacing: 0.4, color: '#1dc2ff', width: 540 }}>Streamline client adoption by creating client profiles. Invite users to join your practice via a custom code and website landing page. Set your pricing and availability.</span>

        <div className='instant-join-session-button'
             style={{ marginTop: 15, marginBottom: 10, borderRadius: 30, paddingRight: 40, paddingLeft: 40 }}
             onClick={ () => {
               let screen_props = {
                 is_updgrade: true,
               }
               history.push({ pathname: routes.PRACTICE_PLANS, state: { props: screen_props } })
             }}>
          <span style={{ fontWeight: 'bold', fontSize: 14 }}>Upgrade</span>
        </div>

        <img className="instant-completed-preview-image" src={preview_image} alt="Icon Text" />
      </div>
    </div>
  }

  renderClientLocations = () => {
    let locations = this.props.practice.locations;
    let sections  = this.getClientSections(locations);

    return <div className='flex-container-row'>
      { sections }
    </div>
  }

  renderAddClientForm = () => {
    return <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
      <Header title='Create a New Client Account' icon='fas fa-user-plus' />
      <div className='flex-container-column' style={{ padding: 15 }}>
      <span style={{ fontSize: 13, color: 'grey', marginBottom: 15 }}>Create a TeleTails account for clients. They will receive login information via email and will be automatically linked with your practice when they first sign in using the email address provided.</span>

      <Input style={{ marginBottom: 10, width: '100%', borderColor: this.state.first_name ? '#1dc2ff' : '' }}
             placeholder="First Name"
             className='instant-input-default'
             value={this.state.first_name}
             onChange={ (event) => { this.setState({ ...this.state, first_name: event.target.value }) }}
          />
      <Input style={{ marginBottom: 10, width: '100%', borderColor: this.state.last_name ? '#1dc2ff' : '' }}
             placeholder="Last Name"
             className='instant-input-default'
             value={this.state.last_name}
             onChange={ (event) => { this.setState({ ...this.state, last_name: event.target.value }) }}
          />
      <Input style={{ marginBottom: 10, width: '100%', borderColor: this.state.email ? '#1dc2ff' : '' }}
             placeholder="Email"
             className='instant-input-default'
             value={this.state.email}
             onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
          />

      <Line style={{ marginTop: 15, marginBottom: 15 }}/>

      <span style={{ color: 'grey', fontWeight: 'bold', marginLeft: 3, marginBottom: 5, fontSize: 10 }}>SELECT LOCATION</span>
      { this.renderSelectLocationSection() }

      <Line style={{ marginTop: 15, marginBottom: 15 }}/>

      <div className='instant-join-session-button'
           style={{  paddingTop: 20, paddingBottom: 20 }}
           onClick={ () => {
             this.createClientAccount();
           }}>
        { this.state.create_client_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
        <span>Create Client Account</span>
      </div>
      </div>
    </div>
  }

  renderInviteClientForm = () => {
    let invite_method = this.state.invite_client_method;
    let is_email      = invite_method === 'email';
    let is_text       = invite_method === 'text';

    return <div className='standard-container' style={{ width: '100%', maxWidth: '100%', minWidth: '100%', flex: 0 }}>
      <Header title='Send a Download Link' icon='fas fa-share' />
      <div className='flex-container-column' style={{ padding: 15 }}>
      <span style={{ fontSize: 13, color: 'grey', marginBottom: 15 }}>Enter a client’s email or cell number to send them an invitation to create a TeleTails account.Once completed, they will be linked to your practice.</span>

      <div className='flex-container-row' style={{ width: '100%', marginBottom: 5 }}>
          <div className='color-button-border flex-container-row'
               style={{ justifyContent: 'center', alignItems: 'center', flex: 1, marginRight: 2, padding: 5, borderWidth: 2, borderRadius: 5, borderColor: is_email ? '#1dc2ff' : '' }}
               onClick={ () => { this.setState({ ...this.state, invite_client_method: 'email' }) }}>
            <span className='fas fa-envelope' style={{ color: '#1dc2ff', marginBottom: 1 }}/>
            <span style={{ fontSize: 13, color: '#575757', marginLeft: 10 }}>Email</span>
            <span className='fas fa-envelope' style={{ color: 'white' }}/>
          </div>
          <div className='color-button-border flex-container-row'
               style={{ justifyContent: 'center', alignItems: 'center', flex: 1, marginLeft: 2, padding: 5, borderWidth: 2, borderRadius: 5, borderColor: is_text ? '#1dc2ff' : '' }}
               onClick={ () => { this.setState({ ...this.state, invite_client_method: 'text' }) }}>
            <span className='fas fa-comment' style={{ color: '#1dc2ff', marginBottom: 1 }}/>
            <span style={{ fontSize: 13, color: '#575757', marginLeft: 10 }}>Text</span>
            <span className='fas fa-comment' style={{ color: 'white' }}/>
          </div>
      </div>

      { is_email ? <Input style={{ width: '100%', height: 36 }}
                       placeholder="Email"
                       className='instant-input-default'
                       value={this.state.invite_email}
                       onChange={ (event) => { this.setState({ ...this.state, invite_email: event.target.value }) }}
                    />

                  : <PhoneInput value={this.state.invite_phone_number}
                              style={{ fontSize: 13, width: 180 }}
                              placeholder='Cell Phone'
                              containerStyle={{ width: '100%' }}
                              onChange={ (phone_number) => { this.setState({ ...this.state, invite_phone_number: phone_number }) }} /> }

        <Line style={{ marginTop: 15, marginBottom: 15 }}/>

        <span style={{ color: 'grey', fontWeight: 'bold', marginLeft: 3, marginBottom: 5, fontSize: 10 }}>SELECT LOCATION</span>
        { this.renderInviteSelectLocationSection() }

        <div className='instant-join-session-button'
             style={{ marginTop: 15, paddingTop: 20, paddingBottom: 20 }}
             onClick={ () => {
               this.inviteClientAction();
             }}>
          { this.state.invite_client_loading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 8 }} /> : null }
          <span>Send Invite</span>
        </div>
      </div>
    </div>
  }

  renderInviteSelectLocationSection = () => {
    let locations     = this.props.practice.locations;
    let all_locations = Object.values(locations);

    let location_rows = all_locations.map((location, index) => {
      let is_selected = this.state.invite_location_id === location._id;
      let name        = location.name;
      let bottom_marg = all_locations.length === index + 1 ? 0 : 5;
      let border_clr  = is_selected ? '#1dc2ff' : '';
      let icon_name   = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
      let icon_color  = is_selected ? '#1dc2ff' : '#e7e7e7';
      return <div className='color-button-border flex-container-row'
                  key={index}
                  style={{ justifyContent: 'space-between', alignItems: 'center', borderColor: border_clr, marginBottom: bottom_marg, padding: 8, borderWidth: 2, borderRadius: 5 }}
                  onClick={ () => {
                    let selected_location = this.state.invite_location_id === location._id ? '' : location._id;
                    this.setState({ ...this.state, invite_location_id: selected_location });
                  }}>
        <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
        <span className={icon_name} style={{ color: icon_color }} />
      </div>
    }).filter((row) => { return row });

    return <div>
      { location_rows }
    </div>
  }

  renderSelectLocationSection = () => {
    let locations     = this.props.practice.locations;
    let all_locations = Object.values(locations);

    let location_rows = all_locations.map((location, index) => {
      let is_selected = this.state.location_id === location._id;
      let name        = location.name;
      let bottom_marg = all_locations.length === index + 1 ? 0 : 5;
      let border_clr  = is_selected ? '#1dc2ff' : '';
      let icon_name   = is_selected ? 'fas fa-check-circle' : 'far fa-circle';
      let icon_color  = is_selected ? '#1dc2ff' : '#e7e7e7';
      return <div className='color-button-border flex-container-row'
                  key={index}
                  style={{ justifyContent: 'space-between', alignItems: 'center', borderColor: border_clr, marginBottom: bottom_marg, padding: 8, borderWidth: 2, borderRadius: 5 }}
                  onClick={ () => {
                    let selected_location = this.state.location_id === location._id ? '' : location._id;
                    this.setState({ ...this.state, location_id: selected_location });
                  }}>
        <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
        <span className={icon_name} style={{ color: icon_color }} />
      </div>
    }).filter((row) => { return row });

    return <div>
      { location_rows }
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          practice={this.props.practice.practice}
          userActions={this.props.userActions}
        />
        <NavBar
          practice={this.props.practice.practice}
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          currentRoute={routes.CLIENTS}
          notifications={this.props.notifications}
        />

        { this.renderContentContainers() }

      </div>
    );
  }

  getClientSections = (locations) => {
    let location_rows  = [];
    let all_locations  = Object.values(locations);
    let first_location = null;

    all_locations.forEach((location) => {
      let name        = location.name;
      let title       = name;
      let location_id = location._id;

      first_location  = !first_location ? location : first_location;

      location_rows.push(
        <div className='flex-container-column' key={location_id}>
          <div className='standard-selection-row' style={{ padding: 8, paddingLeft: 15 }}
               onClick={ () => {
                 let screen_props = {
                   location: location,
                 }
                 history.push({ pathname: routes.LOCATION_CLIENTS, state: { props: screen_props } });
               }}>
            <span style={{ color: '#575757', fontSize: 13 }}>{ name }</span>
          </div>
          <Line style={{ backgroundColor: '#f5f5f5' }} />
        </div>
      );
    });

    return <div className='standard-container' style={{ }}>
      <Header title='Select a location to view clients' icon='fas fa-users' button_title='See All'
              button_action={ () => {
                let screen_props = {
                  location: first_location,
                }
                history.push({ pathname: routes.LOCATION_CLIENTS, state: { props: screen_props } })
              }} />
      { location_rows }
    </div>
  }

  fetchClientsForLocations = (locations) => {
    let all_locations = Object.values(locations);
    let practice_id   = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';
    let token         = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';

    all_locations.forEach((location) => {
      let location_id = location._id;
      this.props.practiceActions.getPreviewClientsForLocation(token, practice_id, location_id, this.fetch_clients_success, this.fetch_clients_failure);
    });

  }

  fetch_clients_success = (location_id, clients) => {
    let existing_object = Object.assign({}, this.state.location_clients);
    let updated_clients = clients || [];

    existing_object[location_id] = clients;
    this.setState({ ...this.state, location_clients: existing_object })
  }

  fetch_clients_failure = (location_id, clients) => {

  }

  createClientAccount = () => {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let first_name  = this.state.first_name;
    let last_name   = this.state.last_name;
    let email       = this.state.email;
    let location_id = this.state.location_id;
    let practice_id = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';

    if (!first_name || !last_name || !email) {
      this.props.toastActions.displayError('First Name, Last Name and Email are required fields.');
      return;
    }

    if (!location_id) {
      this.props.toastActions.displayError('Please select a location to add this client to.');
      return;
    }

    let client_object = {
      first_name: first_name,
      last_name: last_name,
      email: email,
      practice_id: practice_id,
      location_id: location_id,
    }

    this.props.practiceActions.createClientAccount(token, client_object, this.clientCreationSuccess, this.clientCreationFailure );
    this.setState({ ...this.state, create_client_loading: true });
  }

  clientCreationSuccess = (location_id) => {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let practice_id = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';
    this.props.practiceActions.getPreviewClientsForLocation(token, practice_id, location_id, this.fetch_clients_success, this.fetch_clients_failure);
    this.setState({
      ...this.state,
      create_client_loading: false,
      first_name: '',
      last_name: '',
      email: '',
      location_id: '',
    });
  }

  clientCreationFailure = () => {
    this.setState({ ...this.state, create_client_loading: false });
  }

  inviteClientAction = () => {
    let token       = this.props.user && this.props.user.auth && this.props.user.auth.token ? this.props.user.auth.token : '';
    let email       = this.state.invite_email;
    let phone       = this.state.invite_phone_number;
    let location_id = this.state.invite_location_id;
    let practice_id = this.props.practice && this.props.practice.info && this.props.practice.info._id ? this.props.practice.info._id : '';

    let method   = this.state.invite_client_method;
    let is_email = method === 'email';
    let is_text  = method === 'text';

    if (is_email && !email) {
      this.props.toastActions.displayError("Enter a client's email address");
      return;
    }

    if (is_text && !phone) {
      this.props.toastActions.displayError("Enter a client's phone number");
      return;
    }

    if (!location_id) {
      this.props.toastActions.displayError("Select a location");
      return;
    }

    let invite_object = {
      email: is_email ? email : '',
      phone: is_text  ? phone : '',
      practice_id: practice_id,
      location_id: location_id,
    }

    this.props.practiceActions.inviteClient(token, invite_object, this.clientInviteSuccess, this.clientInviteFailure);
    this.setState({ ...this.state, invite_client_loading: true });
  }

  clientInviteSuccess = () => {
    this.setState({
      ...this.state,
      invite_client_loading: false,
      invite_phone_number: '',
      invite_location_id: '',
      invite_email: '',
    });
  }

  clientInviteFailure = () => {
    this.setState({ ...this.state, invite_client_loading: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientsScreen)
